export default "__VITE_ASSET__CFf5AFN5__"